import { IsArray, IsIn, IsOptional, IsString } from 'class-validator';

import { CrudItemListRequest } from '../../crud/crud-item-list.request';
import { NomenclatureAccountingType } from '../enum/nomenclature-accounting-type';

export class NomenclatureTypeGetListRequest extends CrudItemListRequest {
    /**
     * Skip nomenclature type by supplied uuid and all parents
     */
    @IsOptional()
    @IsString()
    public filterByNomenclatureTypeUuid?: string;

    @IsOptional()
    @IsArray()
    @IsIn([
        NomenclatureAccountingType.ACCOUNTING_TYPE_KIT,
        NomenclatureAccountingType.ACCOUNTING_TYPE_PRODUCT,
        NomenclatureAccountingType.ACCOUNTING_TYPE_SERVICE,
    ], { each: true })
    public accountingType?: NomenclatureAccountingType[];

    constructor(data?: Partial<NomenclatureTypeGetListRequest>) {
        super(data);
        this.filterByNomenclatureTypeUuid = data && data.filterByNomenclatureTypeUuid;
        this.accountingType = data && data.accountingType;
    }
}
